var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldConditionsExpandUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyboard_arrow_up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/hardware/keyboard_arrow_up_24px",
    d: "M7.41 15.7069L12 11.1269L16.59 15.7069L18 14.2969L12 8.29688L6 14.2969L7.41 15.7069Z",
    fill: "#696F88"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldConditionsExpandUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field-conditions-expand-up.5369f602317a9449579ad1ca65cb3287.svg";